import React, { useContext, useState } from 'react';
import { BackArrowIcon, RedXIcon } from 'assests/GmsIcons';
import { useHistory } from 'react-router-dom';
import { IN_PROGRESS_STATUS, STOP } from '../../utils/Constants';
import CustomChip from '../../components/CustomChip';
import ABPromoteModal from '../../components/ABPromoteModal';
import { computeABTestResult } from '../../services/ABServices';
import { ABContext } from '../../contexts/ABContext';
import { getDaysBetween } from '../../utils/ABHelper';
import AuthManager from 'Common/AuthManager';
import ABStopModal from '../../components/ABStopModal';
import { toast } from 'react-toastify';
import { TABResult } from '../../types/ab';

type TABResultHeaderProps = {
    testName?: string;
    testId: string;
}

const ABResultHeader = ({ testName, testId }: TABResultHeaderProps) => {
    const history = useHistory();
    const [showPromotModal, setShowPromoteModal] = useState<boolean>(false)
    const [showStopModal, setShowStopModal] = useState<boolean>(false)
    const abContext = useContext(ABContext);
    const { testData, setTestData, setSelectedModelId } = abContext;

    const remainingDays = getDaysBetween(testData?.test_duration, testData?.analyzed_duration);
    const dayText = remainingDays === 1 ? 'day' : 'days';

    const userobj = AuthManager.getAuthUser();
    const userProfile = userobj?.profile;
    const userid = userProfile?.id;
    const onBackPress = () => { history?.push('/gms/ab'); setTestData(null) }

    const handlePostStop = async () => {
        setShowStopModal(false)
        setShowPromoteModal(true)
    }

    const handleStop = () => {
        if(testData?.ownership?.userid !== userid){
            toast.error('You can only stop A/B Tests that you have created.')
            return
        }
        const controlModel = testData?.result?.find((x: TABResult) => x?.is_control)?.id
        setSelectedModelId(controlModel)
        setShowStopModal(true)
    }

    const handleOnCancel = async () => {
        setShowPromoteModal(false);
        const testres = await computeABTestResult(testId as string)
        if (testres?.done) {
            setTestData(testres?.data)
        }
        else toast.info(testres?.message)
    }

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-py-1.5 tw-bg-[#FAFAFC]">
            <div className="tw-flex tw-items-center tw-gap-3">
                <button onClick={onBackPress}><BackArrowIcon /></button>
                <label className="tw-text-[#091E42] tw-text-[24px] tw-font-semibold">{testName ?? ''}</label>
                <CustomChip status={testData?.status} />
            </div>
            <div className="tw-flex tw-items-center tw-gap-1">
                <div className="tw-flex tw-items-center tw-gap-3">
                    {/* <button className="outline-button">
                        <div className="tw-flex tw-items-center tw-gap-2">
                            <PauseIcon />
                            <span>{PAUSE}</span>
                        </div>
                    </button> */}
                    {testData?.status === IN_PROGRESS_STATUS
                        ? <>
                            <CustomChip status={
                                <div>
                                    <span className='tw-font-semibold'>{remainingDays > 0 ? remainingDays : 0} {dayText} left </span>in the test
                                </div>
                            } />
                            < button className={`${testData?.ownership?.userid !== userid ? "tw-bg-gray-200 tw-border-[#abaaaa] tw-cursor-not-allowed" : ""} outline-button tw-border-[#BF2600] tw-text-[#BF2600]  hover:tw-bg-[#f5e4df] hover:tw-border-[#BF2600]`} onClick={handleStop}>
                            <div className="tw-flex tw-items-center tw-gap-2">
                                <RedXIcon />
                                <span>{STOP}</span>
                            </div>
                            </button> </> : null}
                </div>
                {/* <div className="tw-flex tw-items-center">
                    <div className="tw-px-2 tw-w-8 tw-rotate-90 tw-border tw-border-[#969fae]" />
                    <button className="button-style tw-w-max" onClick={onPromote}>
                        {PROMOTE}
                    </button>
                </div> */}
            </div>
            {showPromotModal ? <ABPromoteModal onCancel={handleOnCancel} /> : null}
            {showStopModal ? <ABStopModal isOpen={showStopModal} onCancel={() => setShowStopModal(false)} handleStop={handlePostStop} /> : null}
        </div>
    );
}

export default ABResultHeader;